//*Alot Unit from global Leads for events
function setAlotEventLead(data) {
  sessionStorage.setItem('leadEventData', JSON.stringify(data));
}
function getAlotEventLead() {
  return JSON.parse(sessionStorage.getItem('leadEventData'));
}
function setAlotEventGlobalLeadAvailable(data) {
  sessionStorage.setItem('routeFromGlobalLeadEvent', JSON.stringify(data));
}
function getAlotEventGlobalLeadAvailable() {
  return JSON.parse(sessionStorage.getItem('routeFromGlobalLeadEvent'));
}
function setAlotEventGlobalUnitAvailable(data) {
  sessionStorage.setItem('EventUnitAvailable', JSON.stringify(data));
}
function getAlotEventGlobalUnitAvailable() {
  return JSON.parse(sessionStorage.getItem('EventUnitAvailable'));
}

//*Alot Unit from global Leads for sustenance
function setAlotSustenanceLead(leadData) {
  sessionStorage.setItem('leadDetails', JSON.stringify(leadData));
}
function getAlotSustenanceLead() {
  return JSON.parse(sessionStorage.getItem('leadDetails'));
}
function setAlotSustananceGlobalUnitAvailable(data) {
  sessionStorage.setItem('SustananceUnitAvailable', JSON.stringify(data));
}
function getAlotSustananceGlobalUnitAvailable() {
  return JSON.parse(sessionStorage.getItem('SustananceUnitAvailable'));
}
function setAlotSustananceGlobalRoute(data) {
  sessionStorage.setItem('routeFromGlobalLeadSustanance', JSON.stringify(data));
}
function getAlotSustananceGlobalRoute() {
  return JSON.parse(sessionStorage.getItem('routeFromGlobalLeadSustanance'));
}



export {
  setAlotSustenanceLead,
  getAlotSustenanceLead,
  setAlotEventLead,
  getAlotEventLead,
  setAlotEventGlobalLeadAvailable,
  getAlotEventGlobalLeadAvailable,
  setAlotEventGlobalUnitAvailable,
  getAlotEventGlobalUnitAvailable,
  setAlotSustananceGlobalUnitAvailable,
  getAlotSustananceGlobalUnitAvailable,
  setAlotSustananceGlobalRoute,
  getAlotSustananceGlobalRoute,


};
